<template>
  <div>
    <b-container class="home-container container-xl vali-hollow-logo">
      <b-row col="12" class="mb-5">
        <b-col sm="12" md="12" lg="8" xl="6" style=" font-size: 18px; text-align: left">
          <h1 class="text-left">A személyre szabott vállalkozói információ</h1>
          <p class="text-left mt-4" style="font-size: 24px">
            Tájékozódjon vállalkozása számára elérhető támogatásokról, hitelekről, képzési és szakértői
            szolgáltatásokról.
          </p>
        </b-col>
      </b-row>

      <ifka-vp-energy-support-program-section />

      <template v-if="userCompanyOptions.length && isSearchCompany">
        <b-row col="12" class="mb-2 mt-0 justify-content-md-center">
          <b-col sm="12" md="12" lg="12" xl="12">
            <h2 class="text-left">
              Nézze meg a cége lehetőségeit!
            </h2>
          </b-col>
        </b-row>
        <b-row col="12" class="mb-2">
          <b-col>
            <div class="select-company-wrapper rounded">
              <ifka-vp-select-company />
            </div>
          </b-col>
        </b-row>
      </template>
      <template v-if="userSoleProprietorshipOptions.length && !isSearchCompany">
        <b-row col="12" class="mb-2 mt-0 justify-content-md-center">
          <b-col sm="12" md="12" lg="12" xl="12">
            <h2 class="text-left">
              Nézze meg a vállalkozása lehetőségeit!
            </h2>
          </b-col>
        </b-row>
        <b-row col="12" class="mb-2">
          <b-col>
            <div class="select-company-wrapper rounded">
              <SelectSoleProprietorship />
            </div>
          </b-col>
        </b-row>
      </template>
      <!--<b-row col="12" class="mb-2 justify-content-md-center">
        <b-col sm="12" md="6" lg="6">
          <div class="separator mt-4 mb-4">vagy</div>
        </b-col>
      </b-row>-->
      <b-row col="12" class="mb-2 mt-5">
        <b-col sm="12" md="12" lg="12">
          <h2 v-if="isSearchCompany" class="text-left">
            Adjon hozzá még egy céget a profiljához
          </h2>
          <h2 v-else class="text-left">
            Adjon hozzá még egy vállalkozást a profiljához
          </h2>
        </b-col>
      </b-row>
      <b-row col="12" class="mb-5 justify-content-md-center">
        <b-col sm="12" md="12" lg="12">
          <ifka-vp-search-company />
        </b-col>
      </b-row>

      <ifka-vp-programs />
      <ifka-vp-services />
      <ifka-vp-programs-highlight />
      <ifka-vp-news />

      <div class="opacity-logo">
        <b-img src="../assets/img/logo/vekonylogo_vali_horisontal.svg" class="mt-4 mb-4" />
      </div>
    </b-container>
    <b-modal ref="register-success" id="register-success" size="xl" hide-footer>
      <div class="modal-box">
        <h3 class="modal-title">Sikeres regisztráció!</h3>
        <p class="modal-description">
          Most már megnézheti az Ön számára Elérhető lehetőségeket.
        </p>
        <b-button @click="hideSuccessfulRegModal" variant="primary" class="modal-button">Rendben</b-button>
      </div>
      <b-row class="modal-logo-box">
        <b-img src="@/assets/img/logo/success-registraion.svg"></b-img>
      </b-row>
    </b-modal>
    <EuropeanAward />
  </div>
</template>

<script>
import ConstantServices from '@/components/ConstantServices.vue'
import News from '@/components/News.vue'
import Programs from '@/components/Programs.vue'
import ProgramsHighlight from '@/components/ProgramsHighlight.vue'
import SearchCompany from '@/components/SearchCompany.vue'
import SelectCompany from '@/components/SelectCompany.vue'
import SelectSoleProprietorship from '@/components/SelectSoleProprietorship.vue'
import queryString from 'query-string'
import { mapGetters } from 'vuex'
import DSPHeadLine from '../components/DSPHeadLine.vue'
import EuropeanAward from '../components/EuropeanAward.vue'

export default {
  name: 'PrivateHome',
  components: {
    ifkaVpSearchCompany: SearchCompany,
    ifkaVpSelectCompany: SelectCompany,
    SelectSoleProprietorship,
    ifkaVpNews: News,
    ifkaVpPrograms: Programs,
    ifkaVpServices: ConstantServices,
    ifkaVpProgramsHighlight: ProgramsHighlight,
    ifkaVpEnergySupportProgramSection: DSPHeadLine,
    EuropeanAward
  },
  computed: {
    ...mapGetters([
      'isLoading',
      'userCompanyOptions',
      'selectedUserCompany',
      'userCompanies',
      'isSearchCompany',
      'userSoleProprietorshipOptions'
    ])
  },
  async created() {
    if (!this.userCompanyOptions.length) {
      const getParams = {}
      await this.$store.dispatch('getUserCompanies', getParams)
    }

    if (!this.userSoleProprietorshipOptions.length) {
      const getParams = {}
      await this.$store.dispatch('getUserSoleProprietorships', getParams)
    }

    if (this.userCompanies[0] && !this.selectedUserCompany) {
      this.$store.commit('setSelectedUserCompany', this.userCompanies[0])
    }
  },
  mounted() {
    const params = queryString.parse(location.search)
    const { reg_ok } = params
    if (reg_ok) {
      this.showSuccessfulRegModal()
    }
  },
  methods: {
    showSuccessfulRegModal() {
      this.$refs['register-success'].show()
    },
    hideSuccessfulRegModal() {
      this.$refs['register-success'].hide()
      this.$router.push('/home')
    }
  }
}
</script>

<style scoped>
.select-company-wrapper {
  background-color: var(--color-gray00);
  padding: 32px;
}

::v-deep #register-success .modal-dialog {
  display: flex;
  justify-content: center;
}

::v-deep #register-success .modal-content {
  width: 815px;
  height: 640px;
}

.modal-box {
  padding: 70px;
  padding-top: 10px;
}

.modal-title {
  font-weight: 400;
  font-size: 64px;
  line-height: 32px;
  margin-bottom: 62px;
}

.modal-description {
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  margin-bottom: 42px;
}

.modal-button {
  width: 320px;
  height: 60px;
}

.modal-logo-box {
  justify-content: end;
  margin-top: -65px;
  margin-right: 65px;
}

.separator {
  display: flex;
  align-items: center;
  text-align: center;
}

.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #00903c;
}

.separator:not(:empty)::before {
  margin-right: 1.25em;
}

.separator:not(:empty)::after {
  margin-left: 1.25em;
}

@media (max-width: 993px) {
  .select-company-wrapper {
    padding: 8px !important;
  }

  .modal-box {
    padding: 70px;
    padding-top: 0px;
  }

  .modal-title {
    font-weight: 400;
    font-size: 62px;
    line-height: 72px;
  }

  .modal-button {
    margin-top: 50px;
    width: 100%;
  }

  .modal-logo-box {
    display: none;
  }
}

.vali-logo {
  max-width: 200px;
  margin-left: -15px;
}

@media (min-width: 992px) {
  .vali-hollow-logo {
    position: relative;
    overflow: hidden;
  }

  .vali-hollow-logo:before {
    content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    opacity: 0.2;
    background-image: url('../assets/img/logo/vekonyvali_hollow.svg');
    background-repeat: no-repeat;
    background-position: 100% 0;
    background-size: 394px;
  }

  .opacity-logo {
    width: 312px;
    max-width: 312px;
    margin: 0 auto;
    opacity: 0.6;
  }
}
</style>
